import * as QA from 'shared/utils/queryAnalysis';
import { areStringsInsensitivelyEqual, asString } from 'shared/utils/utils';


export class PicklistConverter {
  static Mode = {
    ToName: 'name',
    ToLabel: 'label',
    NameToLabel: 'name-to-label',
    LabelToName: 'label-to-name',
  };

  constructor(rawField) {
    this.isMultiselect = QA.isMultiselectPicklistField(rawField);
    this.values = rawField.picklistValues.reduce((out, { active, label, value }) => {
      active && out.push({ label, name: value });
      return out;
    }, []);
  }

  convert(item) {
    return this.cvt(item, PicklistConverter.Mode.ToName);
  }

  cvt(item, mode) {
    const PCM = PicklistConverter.Mode;
    const searchInNames = mode !== PCM.LabelToName;
    const searchInLabels = mode !== PCM.NameToLabel;
    const nameAsResult = mode === PCM.ToName || mode === PCM.LabelToName;

    const itemString = asString(item);
    const items = this.isMultiselect ? itemString.split(';') : [itemString];
    const value = items.map(x => {
      // Don't merge finds' condition into one find(x => ... || ...)
      const search = (searchInLabels && this.values.find(y => areStringsInsensitivelyEqual(y.label, x)))
        || (searchInNames && this.values.find(y => areStringsInsensitivelyEqual(y.name, x)));
      return search
        ? nameAsResult ? search.name : search.label
        : x;
    }).join(';');

    // console.log(`Converted '${item}' to '${value}'`)
    return { value };
  }
}


export function getPicklistConverter(field) {
  const cvt = new PicklistConverter(field);
  return (item) => cvt.convert(item);
}

